{
  "title": "Hesap",
  "registerTitle": "Kayıt",
  "subtitle": "E-posta, Google, telefon veya Telegram ile giriş yapın — her yöntem aynı hesabı ve cüzdanı açar.",
  "email": "E-posta",
  "password": "Şifre",
  "showPassword": "Göster",
  "hidePassword": "Gizle",
  "acceptTerms": "Kullanım koşullarını kabul ediyorum",
  "registerCta": "Hesap oluştur",
  "haveAccount": "Zaten hesabınız var mı?",
  "needAccount": "Hesaba mı ihtiyacınız var?",
  "telegramHint": "Telegram Mini App otomatik girişi etkin (initData sunucuda doğrulanır).",
  "unavailable": "Kimlik doğrulama henüz aktif değil",
  "telegramSoon": "Telegram girişi yakında",
  "webSoon": "Web girişi yakında",
  "googleDisabled": "OAuth yapılandırılana kadar Google girişi kapalı",
  "googleReady": "Google ile devam et",
  "smsDisabled": "SMS sağlayıcısı yapılandırılana kadar SMS girişi kapalı",
  "smsReady": "Telefon ile devam et",
  "orEmail": "E-posta",
  "registerShort": "Kayıt ol",
  "loginTitle": "Giriş yap",
  "tabEmail": "E-posta",
  "tabPhone": "Telefon",
  "emailPlaceholder": "E-posta",
  "phoneUnavailableTitle": "Telefonla giriş henüz aktif değil",
  "phoneUnavailableBody": "SMS gönderimi bağlı değil. E-posta ve şifre ile devam edin.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "9 haneli Azerbaycan cep numarası girin (örn. 50 123 45 67).",
  "casinoBonusInactive": "Henüz aktif kampanya yok",
  "socialMethods": "Sosyal giriş",
  "orContinue": "veya",
  "continueWithTelegram": "Telegram ile devam et",
  "casinoBonus": "Casino bonusu",
  "noRegistrationBonus": "Şu an seçilebilecek kayıt bonusu yok.",
  "promoToggle": "Promosyon kodu ekle",
  "promoPlaceholder": "Promosyon kodu",
  "promoHint": "Kod kayıt sırasında uygulanmaz. Daha sonra Bonuslar sayfasından girebilirsiniz.",
  "acceptTermsPrefix": "Okudum ve kabul ediyorum: ",
  "acceptTermsLink": "kullanım koşulları",
  "acceptTermsSuffix": ".",
  "acceptTermsRequired": "Kayıt olmak için koşulları kabul etmelisiniz.",
  "termsMissingNote": "Kuralların taslağı /qaydalar adresinde. Üretime yayın ayrı onay gerektirir. Kayıt için kutuyu işaretleyin.",
  "registerSubmit": "Hesap oluştur",
  "loginSubmit": "Giriş yap",
  "socialSoon": "Google ve Telegram web girişi henüz aktif değil.",
  "haveAccountPrompt": "Zaten hesabınız var mı?",
  "haveAccountAction": "Giriş yap",
  "needAccountPrompt": "Hesaba mı ihtiyacınız var?",
  "needAccountAction": "Kayıt ol",
  "resetPassword": "Şifreyi sıfırla",
  "closeDialog": "Kapat",
  "forgotLink": "Şifrenizi mi unuttunuz?",
  "forgotTitle": "Şifreyi sıfırla",
  "forgotIntro": "Hesabınızın e-postasını girin. Kayıtlıysa sıfırlama bağlantısı gönderilir.",
  "forgotCta": "Sıfırlama bağlantısı gönder",
  "forgotSent": "Bu e-posta ile bir hesap varsa sıfırlama bağlantısı yolda. Gelen kutunuzu ve spam klasörünü kontrol edin.",
  "sendAgain": "Tekrar gönder",
  "emailDeliveryOff": "Bu sunucuda e-posta gönderimi henüz yapılandırılmadı, bu yüzden mesaj gelmeyecek.",
  "backToLogin": "Girişe dön",
  "resetTitle": "Yeni bir şifre seçin",
  "newPassword": "Yeni şifre",
  "confirmPassword": "Şifreyi tekrarla",
  "passwordsDontMatch": "Şifreler eşleşmiyor",
  "passwordRules": "En az 8 karakter; harfleri rakam veya sembollerle karıştırın.",
  "resetCta": "Yeni şifreyi kaydet",
  "resetDone": "Şifre değiştirildi. Tüm oturumlar kapatıldı — yeni şifreyle giriş yapın.",
  "linkInvalid": "Bu bağlantı geçersiz, süresi dolmuş veya zaten kullanılmış.",
  "requestNewLink": "Yeni bağlantı iste",
  "checking": "Kontrol ediliyor...",
  "verifyTitle": "E-postayı onayla",
  "verifyIntro": "E-posta adresinizi onaylamak için düğmeye basın.",
  "verifyCta": "E-postayı onayla",
  "verifyDone": "E-posta onaylandı. Teşekkürler!",
  "verifyResendHint": "Güvenlik sayfasından yeni bir onay e-postası isteyebilirsiniz.",
  "securityTitle": "Hesap güvenliği",
  "emailVerified": "Doğrulandı",
  "emailNotVerified": "Doğrulanmadı",
  "resendVerification": "Onay e-postasını tekrar gönder",
  "verificationSent": "Onay e-postası gönderildi.",
  "verificationSentAfterRegister": "Hesap oluşturuldu. E-postanıza bir onay bağlantısı gönderdik.",
  "phoneTitle": "Telefon ile giriş",
  "phoneLinkTitle": "Telefon numarası ekle",
  "phoneLabel": "Telefon numarası",
  "phoneHint": "Azerbaycan numaraları 050 123 45 67 olarak yazılabilir. Diğer ülkeler için + ile başlayın.",
  "sendCode": "Kod gönder",
  "codeLabel": "SMS kodu",
  "codeSentTo": "{{phone}} numarasına 6 haneli kod gönderdik.",
  "verifyCode": "Onayla",
  "resendCode": "Kodu tekrar gönder",
  "resendIn": "{{seconds}} sn içinde tekrar gönder",
  "changeNumber": "Numarayı değiştir",
  "phoneLinked": "Telefon numarası eklendi.",
  "googleWorking": "Google ile giriş yapılıyor...",
  "googleLinked": "Google hesabı bağlandı.",
  "googleCancelled": "Google girişi iptal edildi.",
  "telegramWorking": "Telegram ile giriş yapılıyor...",
  "telegramCancelled": "Telegram girişi iptal edildi.",
  "signInToLink": "Hesabınıza giriş yapın",
  "telegramWidgetUnavailable": "Telegram web girişi, bot alanı yapılandırıldığında kullanılabilir. Telegram içinde Mini App sizi otomatik giriş yapar.",
  "telegramLinked": "Telegram bağlandı.",
  "signInRequired": "Hesap güvenliğini yönetmek için giriş yapın.",
  "loginMethods": "Giriş yöntemleri",
  "methodPassword": "E-posta ve şifre",
  "methodGoogle": "Google",
  "methodPhone": "Telefon (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Bağlı",
  "notLinked": "Bağlı değil",
  "link": "Bağla",
  "unlink": "Bağlantıyı kaldır",
  "unlinked": "Giriş yöntemi kaldırıldı.",
  "lastMethodHint": "Tek giriş yönteminiz kaldırılamaz.",
  "unavailableProvider": "Yapılandırılmadı",
  "changePasswordTitle": "Şifreyi değiştir",
  "setPasswordTitle": "Şifre belirle",
  "currentPassword": "Mevcut şifre",
  "savePassword": "Şifreyi kaydet",
  "passwordSaved": "Şifre kaydedildi. Diğer oturumlar kapatıldı.",
  "changeEmailTitle": "E-postayı değiştir",
  "newEmail": "Yeni e-posta",
  "saveEmail": "E-postayı kaydet",
  "emailSaved": "E-posta güncellendi. Yeni adresi gelen kutunuzdan onaylayın.",
  "reauthTitle": "Kimliğinizi doğrulayın",
  "reauthIntro": "Güvenliğiniz için devam etmek üzere şifrenizi girin.",
  "reauthPasswordless": "Güvenliğiniz için devam etmek üzere tekrar giriş yapın.",
  "reauthCta": "Devam",
  "mfaCode": "Doğrulama uygulaması kodu",
  "signInAgain": "Tekrar giriş yap",
  "sessionsTitle": "Oturumlar",
  "logout": "Çıkış yap",
  "logoutAll": "Tüm cihazlardan çıkış yap",
  "phoneNotSet": "Telefon numarası yok",
  "errors": {
    "invalid_credentials": "E-posta veya şifre hatalı.",
    "too_many_requests": "Çok fazla deneme. Lütfen biraz bekleyip tekrar deneyin.",
    "email_taken": "Bu e-posta zaten kayıtlı. Bunun yerine giriş yapın.",
    "password_too_short": "Şifre çok kısa (en az 8 karakter).",
    "password_too_long": "Şifre çok uzun (en fazla 128 karakter).",
    "password_too_weak": "Şifre çok zayıf. Harfleri rakam veya sembollerle karıştırın.",
    "password_too_common": "Bu şifre çok yaygın. Başka bir şifre seçin.",
    "password_contains_email": "Şifre e-posta adınızı içermemelidir.",
    "invalid_or_expired_token": "Bu bağlantı geçersiz, süresi dolmuş veya zaten kullanılmış.",
    "invalid_password": "Şifre hatalı.",
    "invalid_email": "Geçerli bir e-posta adresi girin.",
    "email_not_set": "Hesabınızda e-posta adresi yok.",
    "reauth_required": "Devam etmek için kimliğinizi doğrulayın.",
    "password_not_set": "Bu hesabın şifresi yok. Bağlı yönteminizle tekrar giriş yapın.",
    "email_required_for_password": "Şifre belirlemeden önce bir e-posta adresi ekleyin.",
    "email_delivery_unavailable": "E-posta gönderimi henüz yapılandırılmadı.",
    "sms_disabled": "SMS ile giriş henüz kullanılamıyor.",
    "phone_auth_disabled": "Telefonla kayıt ve SMS girişi geçici olarak kapalı.",
    "sms_delivery_failed": "SMS gönderilemedi. Daha sonra tekrar deneyin.",
    "invalid_phone": "Geçerli bir telefon numarası girin.",
    "resend_cooldown": "Yeni kod istemeden önce lütfen bekleyin.",
    "otp_invalid": "Kod hatalı veya süresi dolmuş.",
    "otp_expired": "Kodun süresi doldu. Yeni bir kod isteyin.",
    "otp_attempts_exceeded": "Çok fazla hatalı kod. Yeni bir kod isteyin.",
    "phone_in_use": "Bu telefon numarası başka bir hesaba ait.",
    "phone_signin_conflict_retry": "Lütfen tekrar deneyin.",
    "google_oauth_disabled": "Google girişi henüz kullanılamıyor.",
    "telegram_oidc_disabled": "Telegram web girişi henüz kullanılamıyor.",
    "google_account_exists_link_required": "Bu Google e-postasıyla bir hesap zaten var. Önce o hesaba giriş yapın, ardından Güvenlik sayfasından Google'ı bağlayın.",
    "google_linked_to_other_account": "Bu Google hesabı başka bir VBB PLAY hesabına bağlı.",
    "google_other_account_linked": "Farklı bir Google hesabı zaten bağlı. Önce bağlantısını kaldırın.",
    "google_signin_conflict_retry": "Lütfen tekrar deneyin.",
    "invalid_state": "Giriş denemesi süresi doldu veya başka bir tarayıcıda başlatıldı. Lütfen tekrar deneyin.",
    "state_expired": "Giriş denemesinin süresi doldu. Lütfen tekrar deneyin.",
    "nonce_mismatch": "Sosyal giriş doğrulanamadı. Lütfen tekrar deneyin.",
    "invalid_id_token": "Sosyal giriş doğrulanamadı. Lütfen tekrar deneyin.",
    "token_exchange_failed": "Sosyal giriş onaylanmadı. Lütfen tekrar deneyin.",
    "signing_key_unavailable": "Sosyal giriş geçici olarak kullanılamıyor. Lütfen tekrar deneyin.",
    "link_session_mismatch": "Bağlamayı başlatan aynı hesaba giriş yapın.",
    "telegram_already_linked": "Bu Telegram hesabı başka bir VBB PLAY hesabına bağlı.",
    "telegram_other_account_linked": "Farklı bir Telegram hesabı zaten bağlı. Önce bağlantısını kaldırın.",
    "telegram_payload_required": "Telegram giriş verisi döndürmedi.",
    "auth_data_replayed": "Bu Telegram girişi zaten kullanıldı. Lütfen tekrar giriş yapın.",
    "auth_data_expired": "Telegram girişinin süresi doldu. Lütfen tekrar deneyin.",
    "invalid_hash": "Telegram girişi doğrulanamadı.",
    "last_login_method": "Tek giriş yönteminiz kaldırılamaz.",
    "account_suspended": "Bu hesap askıya alındı. Destek ile iletişime geçin.",
    "admin_email_change_disabled": "Yönetici e-postaları yalnızca bir operatör tarafından değiştirilebilir.",
    "mfa_required": "Doğrulama uygulamanızdaki kodu girin."
  }
}
